module.exports = __webpack_public_path__ + "resources/img/img_watchall_sms1.306016efbec3ba8561f6c21a4d7314d1.png";